export default __webpack_public_path__ + "static/media/image11.762aba47.png";